/**
 * HTTP layer for per-customer product catalogs. The negotiated product list a
 * customer may order from (`/warehouse/customer-catalogs`).
 *
 * Contains:
 * - fetchCustomerCatalog / fetchCustomerCatalogsByProduct: catalog reads
 * - postCustomerCatalog / patchCustomerCatalog: catalog writes
 */
import apiClient from '@sophocles/http-common';

const CUSTOMER_CATALOG_ENDPOINT = '/warehouse/customer-catalogs';

export const fetchCustomerCatalog = (customerId, excludeAllCustomers = false) =>
  apiClient
    .get(`${CUSTOMER_CATALOG_ENDPOINT}/${customerId}/`, {
      params: {
        exclude_all_customers: excludeAllCustomers,
      },
    })
    .then(res => res.data);

export const fetchCustomerCatalogsByProduct = productId =>
  apiClient
    .get(`${CUSTOMER_CATALOG_ENDPOINT}/`, {
      params: {
        product_id: productId,
      },
    })
    .then(res => res.data);

export const patchCustomerCatalog = (customerId, data) =>
  apiClient.patch(`${CUSTOMER_CATALOG_ENDPOINT}/${customerId}/`, data).then(res => res.data);

export const postCustomerCatalog = data => apiClient.post(`${CUSTOMER_CATALOG_ENDPOINT}/`, data).then(res => res.data);
